import type { TenantConfig } from '@/types/TenantConfig'

const gold = '#996d15'
const lightGrey = '#e6e6e6'

export const mgmresorts: TenantConfig = {
  logo: 'assets/mgmresorts/static/logo.svg',
  themeOptions: {
    primaryColor: gold,
    secondaryColor: gold,
    logoHeight: '36px',
    headerHeight: '70px',
    headerBottomBorder: `1px solid ${lightGrey}`,
    footerBackgroundColor: 'black',
    footerTextColor: 'white',
    cartHeaderBackgroundColor: 'black',
    memberLinksColor: 'black',
    memberLinksColorHover: '#555555',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/mgmresorts/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
